export enum SimphonyVersion {
  V1 = 'v1',
  V2 = 'v2',
  TOPGOLF = 'topgolf',
}
